import type { TNode } from 'platejs'
import { Node } from 'slate'

import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

/**
 *
 */
function getContent({ editor }: { editor: BufferEditor }): string {
  const texts = editor.children?.map((node: TNode) => {
    return node.type === 'p' ? `${Node.string(node)}` : ''
  })

  const content = texts.join(' ').trim()

  return content
}

export { getContent }
